import { useEffect, useState } from 'react';
import { Download, Share2, Printer } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { receiptModel, renderReceipt, receiptFiles, downloadReceipt, shareReceipt } from '../lib/receipt';

export default function ReceiptPanel({ transaction }) {
  const { user } = useAuth();
  const [ready, setReady] = useState(null);
  const [error, setError] = useState('');
  const [format, setFormat] = useState('png');
  const [sharing, setSharing] = useState(false);
  const [revision, setRevision] = useState(0);
  const modelJson = JSON.stringify(receiptModel(transaction, user));
  useEffect(() => {
    let cancelled = false;
    let preview;
    setReady(null); setError('');
    renderReceipt(JSON.parse(modelJson)).then(async canvas => {
      const files = await receiptFiles(canvas, transaction.id);
      if (cancelled) return;
      preview = URL.createObjectURL(files.png);
      setReady({ files, preview, modelJson });
    }).catch(err => { if (!cancelled) setError(err.message || 'Bukti transaksi gagal dibuat.'); });
    return () => { cancelled = true; if (preview) URL.revokeObjectURL(preview); };
  }, [modelJson, transaction.id, revision]);
  const file = ready?.modelJson === modelJson ? ready.files[format] : null;
  return <section className="space-y-3" aria-label="Bukti transaksi">
    {error ? <div role="alert" className="text-sm text-destructive">{error}<Button variant="outline" onClick={() => setRevision(v => v + 1)}>Coba lagi</Button></div> : !file ? <p role="status" className="text-sm text-muted-foreground">Menyiapkan bukti transaksi…</p> : <img className="print-receipt w-full max-w-md mx-auto rounded-xl border border-border" src={ready.preview} alt={`Bukti ${JSON.parse(modelJson).label}, ${transaction.product?.name || transaction.product_name || ''}, ID ${transaction.id}`} />}
    <div className="flex items-center gap-3"><label htmlFor={`receipt-format-${transaction.id}`} className="text-sm">Format bukti</label><select id={`receipt-format-${transaction.id}`} className="rounded-lg border border-border bg-background p-2 text-sm" value={format} disabled={sharing} onChange={e => setFormat(e.target.value)}><option value="png">Gambar PNG</option><option value="pdf">Dokumen PDF</option></select></div>
    <div className="flex flex-wrap gap-2">
      <Button variant="outline" disabled={!file || sharing} onClick={() => downloadReceipt(file)}><Download className="h-4 w-4 mr-2" />Simpan {format.toUpperCase()}</Button>
      <Button variant="outline" disabled={!file || sharing} onClick={async () => {
        setSharing(true);
        try { if (await shareReceipt(file) === 'downloaded') toast.success('Bukti diunduh. Lampirkan file ini di aplikasi pesan Anda.'); }
        catch (err) { toast.error(err.message || 'Bukti gagal dibagikan. Gunakan tombol Simpan.'); }
        finally { setSharing(false); }
      }}><Share2 className="h-4 w-4 mr-2" />{sharing ? 'Membagikan…' : `Bagikan ${format.toUpperCase()}`}</Button>
      <Button variant="outline" disabled={!file} onClick={() => window.print()}><Printer className="h-4 w-4 mr-2" />Cetak</Button>
    </div>
  </section>;
}
